import { AllocatedNestedQuota } from './allocated-nested-quota';
import { IndividualQuotaAllocation } from './individual-quota-allocation';

export interface NestingAudit {
  distribute(offset: number): AllocatedNestedQuota[];
}

export class HighestPercentAllocation implements NestingAudit {
  constructor(private readonly _allocations: AllocatedNestedQuota[]) {}

  public distribute(offset: number): AllocatedNestedQuota[] {
    if (this._allocations.length === 0) {
      return this._allocations;
    }

    this._allocations.sort((a, b) => b.percentage() - a.percentage());
    const multiplier = this._multiplier(offset);
    const remaining = new Array(Math.abs(offset)).fill(multiplier);

    for (let [i, value] of remaining.entries()) {
      this._allocations[i]?.add(value);
      if (this._allocations[i]?.individualQuotas().length) {
        new IndividualQuotaAllocation(
          this._allocations[i].allocation(),
          this._allocations[i].individualQuotas()
        ).audit();
      }
    }

    return this._allocations;
  }

  private _multiplier(offset: number): number {
    return offset > 0 ? 1 : -1;
  }
}

export class FirstQuotaAllocation implements NestingAudit {
  constructor(private readonly _allocation: AllocatedNestedQuota[]) {}

  public distribute(offset: number): AllocatedNestedQuota[] {
    if (this._allocation.length) {
      this._allocation[0]?.add(offset);
      if (this._allocation[0]?.individualQuotas().length) {
        new IndividualQuotaAllocation(
          this._allocation[0].allocation(),
          this._allocation[0].individualQuotas()
        ).audit();
      }
    }

    return this._allocation;
  }
}

export class EqualValueAllocation implements NestingAudit {
  constructor(private readonly _allocation: AllocatedNestedQuota[]) {}

  public distribute(offset: number): AllocatedNestedQuota[] {
    const value = this._value(offset);
    for (let eachAllocation of this._allocation) {
      eachAllocation?.add(value);
      if (eachAllocation?.individualQuotas().length) {
        new IndividualQuotaAllocation(
          eachAllocation.allocation(),
          eachAllocation.individualQuotas()
        ).audit();
      }
    }

    return this._allocation;
  }

  private _value(offset: number): number {
    return Math.floor(offset / this._allocation.length);
  }
}
